import React from "react";
import PropTypes from "prop-types";
import StripeCheckout from "react-stripe-checkout";
import firebase from "firebase";
import "firebase/functions";
import { Loader } from "react-loaders";
import config from "../config";
import "./Subscription.css";
import stripeLogo from "../stripe.svg";

const paySubscription = firebase.functions().httpsCallable("paySubscription");
const { stripePublishableKey } = config.stripe;

export default class Subscription extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      isAwaitingUpdate: false
    };
  }

  componentWillReceiveProps(newProps) {
    if (
      newProps.payment.activeSubscription !==
      this.props.payment.activeSubscription
    ) {
      this.setState({ isAwaitingUpdate: false });
    }
  }

  onToken = async token => {
    this.setState({ isAwaitingUpdate: true });
    const result = await paySubscription(token);
  };

  onOpen = () => {
    window.analytics.track("Opens Stripe Checkout Popup");
  };

  render() {
    if (!this.props.user) {
      return null;
    }

    let content;
    if (this.state.isAwaitingUpdate) {
      content = (
        <div className="awaiting-update">
          <Loader type="line-scale" active />
          <p>Finding the perfect GIF...</p>
        </div>
      );
    } else {
      content = (
        <div>
          <StripeCheckout
            name="Outro Membership"
            panelLabel="Join for {{amount}}"
            label="Outro Membership"
            email={this.props.user.email}
            token={this.onToken}
            stripeKey={stripePublishableKey}
            allowRememberMe={false}
            amount={1000}
            ComponentClass="div"
            opened={this.onOpen}
          >
            <div className="upgrade-button">Upgrade my Team</div>
          </StripeCheckout>
          <div className="stripe-logo-container">
            <img src={stripeLogo} alt="stripe-logo" className="stripe-logo" />
          </div>
        </div>
      );
    }

    return <div className="subscription-container">{content}</div>;
  }
}

Subscription.propTypes = {
  payment: PropTypes.shape({
    activeSubscription: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    stripeCustomerID: PropTypes.string.isRequired
  }),
  user: PropTypes.shape({
    email: PropTypes.string.isRequired
  })
};



// WEBPACK FOOTER //
// ./src/components/Subscription.js